export default __webpack_public_path__ + "static/media/menu_hamburger.5e5899b7.svg";